
<d-resizable-dialog
    v-model   = "visible"
    :border   = "false"
    :title    = "name"
    :position = "{ x: position.x, y: position.y }"
    :size     = "{ width: size.width, height: size.height }"
>
    <template v-slot:content>
        <c-dms-viewer
            class         = "dms-viewer"
            :document     = "document"
            :top-right    = "true"
            border-radius = "6px"
        />
    </template>
</d-resizable-dialog>
